import styled from 'styled-components';

const Burger = styled.button`
  position: relative;
  border: none;
  width: 50px;
  height: 30px;
  background: #215988;
  border-radius: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  :hover {
    opacity: 0.5;
  }
`;

const Label = styled.div`
  background: #00f47f;
  right: -3px;
  top: -3px;
  position: absolute;
  width: 14px;
  height: 14px;
  border-radius: 99px;
  font-size: 7px;
  line-height: 14px;
  color: #003765;
`;

export { Burger, Label };
